import { FileDown, FileUp, ListCheck, Plus } from "lucide-react";

import classes from "@/pages/Maintainers/maintainers.module.scss";

const ProductBulkModeSelector = ({ onFileUpload, onIndividualUpload, onDownloadTemplate, refFile }) => {
	return (
		<div className={classes.modal}>
			<div className={classes.upload_cards}>
				<div className={classes.upload_card_wrapper}>
					<div className={classes.modal_card} onClick={() => refFile.current && refFile.current.click()}>
						<div className={classes.modal_card_icon}>
							<FileUp size={100} />
						</div>
						<h6 className={classes.modal_card_title}>
							<span className={classes.modal_card_button}>
								<Plus />
							</span>
							Cargar Planilla
						</h6>
						<div>
							<input ref={refFile} type="file" onChange={onFileUpload} accept=".xlsx,.xls,.csv" className="d-none" />
						</div>
					</div>
					<button className={classes.modal_card_download} onClick={onDownloadTemplate}>
						<FileDown size={14} />
						Descargar Planilla
					</button>
				</div>

				<div className={classes.upload_card_wrapper}>
					<div className={classes.modal_card} onClick={onIndividualUpload}>
						<div className={classes.modal_card_icon}>
							<ListCheck size={100} />
						</div>
						<h6 className={classes.modal_card_title}>
							<span className={classes.modal_card_button}>
								<Plus />
							</span>
							Carga Unitaria
						</h6>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductBulkModeSelector;
